import 'twin.macro'

import DoubleCheckedIcon from 'assets/icons/DoubleCheckedIcon'
import { Button } from 'components/UI/button/button'
import Modal from 'components/UI/modal/modal'
import SubTitle from 'components/UI/sub-title/sub-title'
import Title from 'components/UI/title/title'
import BuyCardContainer from 'components/views/UserCabinet/buy-card-container'
import CardContainer from 'components/views/UserCabinet/card-container'
import { ThemeContext } from 'contexts/theme-context'
import React, { useContext, useEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { ClipLoader } from 'react-spinners'
import { useProductsQuery } from 'redux/api/lk.api'
import { isBuyLandingSelector, mobilePhoneSelector, setIsBuyLanding } from 'redux/store/slices/application-slice'
import { setError } from 'redux/store/slices/error-slice'
import tw from 'twin.macro'

import ApplePayIcon from '../assets/icons/ApplePayIcon'
import GarminPayIcon from '../assets/icons/GarminPayIcon'
import GooglePayIcon from '../assets/icons/GooglePayIcon'
import SamsungPay from '../assets/icons/SamsungPay'
import OrangeEllips from '../assets/images/benefits-container-1-gradient-ellips.webp'
import OrangeEllipsDark from '../assets/images/benefits-container-1-gradient-ellips-dark.webp'
import GreenGradient from '../assets/images/benefits-container-5-green-gradient.webp'
import CartImg from '../assets/images/benefits-container-cart-img.webp'
import Faq from '../components/views/Landing/Faq'
import { useDeviceInfo } from '../hooks/useDeviceInfo'

export type Card = {
  uuid: string
  number_card: string
  balance: { source: string; parsedValue: number }
  product_code: string
  open_date: string
  expiry_date: string
  card_state: string
  card_idn: string
  state: string
  number: string
  gift_date: string
  date_of_gift: string
  date_on_balance: string
  gift_message?: string | null
}

function UserPersonalCabinet() {
  const [open, setOpen] = useState<boolean>(false)
  const { data: products, isLoading, refetch, error } = useProductsQuery(null)
  const { t } = useTranslation()
  const { isMobile } = useDeviceInfo()
  const dispatch = useDispatch()
   const mobilePhone = useSelector(mobilePhoneSelector)
  const isBuyLanding = useSelector(isBuyLandingSelector)
  const mobile_phone = useSelector(mobilePhoneSelector)
  const { theme } = useContext(ThemeContext)
  const handleCloseModal = () => {
    dispatch(setIsBuyLanding(false))
    setOpen(false)
  }
  useEffect(() => {
    isBuyLanding && setOpen(true)
  }, [isBuyLanding])

  useEffect(() => {
    if (error) {
      console.log('error', error)

      dispatch(setError({ code: error?.data?.error.code, description: error?.data?.error.description }))
    }
  }, [error])

  return (
    <div tw='flex flex-col gap-20'>
      <div tw='grid sm:grid-cols-3 grid-cols-1 gap-4 w-full  sm:mt-20 mt-10'>
        {isLoading && <ClipLoader color={theme === 'dark' ? 'white' : 'black'} />}
        {products?.data?.cards.map((item: Card) => (
          <CardContainer data={item} key={item.uuid} refetchProducts={refetch} />
        ))}
        {!isLoading && products?.data?.card_counts < 10 && <BuyCardContainer />}
      </div>
      <div tw='flex flex-col gap-5'>
        <p tw='sm:text-[48px] text-[32px] font-bold'>{t('benefits.title', { ns: 'landing' })}</p>
        <div tw='flex flex-col sm:flex-row gap-8'>
          <div tw='bg-secondary rounded-s32 p-[24px] sm:p-[32px] relative sm:h-[441px] h-[336px] sm:w-[744px] flex flex-col sm:flex-shrink-0 gap-2 overflow-hidden'>
            <Title variant='bold'>{t('benefits.container_1.title', { ns: 'landing' })}</Title>
            <SubTitle>
              <Trans>{t('benefits.container_1.desc', { ns: 'landing' })}</Trans>
            </SubTitle>
            <img src={CartImg} alt='' width={isMobile ? 293 : 517} tw='absolute bottom-0 sm:right-0 right-8 z-10' />
            <img
              src={theme === 'dark' ? OrangeEllipsDark : OrangeEllips}
              alt=''
              width='100%'
              tw='absolute bottom-0 right-0'
            />
          </div>
          <div tw='bg-secondary rounded-s32 p-[24px] sm:p-[32px] relative flex flex-col gap-2 sm:justify-between h-[331px] overflow-hidden w-full min-h-[356px] sm:h-[441px]'>
            <Title variant='bold'>{t('benefits.container_5.title', { ns: 'landing' })}</Title>
            <SubTitle>
              <Trans>{t('benefits.container_5.desc', { ns: 'landing' })}</Trans>
            </SubTitle>
            <div tw='grid grid-cols-2 gap-5 mt-5'>
              <div
                css={[theme === 'dark' ? tw`bg-black-opacity30` : tw`bg-primary`]}
                tw='w-[138px] h-[85px] flex items-center justify-center rounded-xl  border border-grey'
              >
                <ApplePayIcon />
              </div>
              <div
                css={[theme === 'dark' ? tw`bg-black-opacity30` : tw`bg-primary`]}
                tw='w-[138px] h-[85px]  flex items-center justify-center rounded-xl border border-grey'
              >
                <GooglePayIcon />
              </div>
              <div
                css={[theme === 'dark' ? tw`bg-black-opacity30` : tw`bg-primary`]}
                tw='w-[138px] h-[85px] flex items-center justify-center rounded-xl border border-grey'
              >
                <SamsungPay />
              </div>
              <div
                css={[theme === 'dark' ? tw`bg-black-opacity30` : tw`bg-primary`]}
                tw='w-[138px] h-[85px]  flex items-center justify-center rounded-xl border border-grey'
              >
                <GarminPayIcon />
              </div>
            </div>
            <img src={GreenGradient} alt='' width={517} tw='absolute bottom-0 right-0' />
          </div>
        </div>
      </div>
      <Faq />
      <Modal open={open} onClose={() => setOpen(false)} outsideClose={false} withClose={false}>
        <div tw='flex flex-col items-center gap-5'>
          <DoubleCheckedIcon />
          <Title variant='bold'>{t('success.title', { ns: 'cabinet' })}</Title>
          <SubTitle twStyle={tw`text-secondary max-w-[350px] text-center`}>
            {t('success.desc', { ns: 'cabinet', phone: mobile_phone })}
          </SubTitle>
          <Button variant='gradient' onClick={handleCloseModal}>
            {t('success.close', { ns: 'cabinet' })}
          </Button>
        </div>
      </Modal>
    </div>
  )
}

export default UserPersonalCabinet
